/* eslint-disable */
import React, { useEffect, useState } from "react";
import { FaDotCircle } from "react-icons/fa";
import { useFormContext } from "../../providers";
import { ListingFilters } from "../Listings/Filter";

const SearchLocation = ({ type = "stays", showFilters, setShowFilters }) => {
  const { setValue, watch } = useFormContext();

  // Function to check window width and update showFilters state
  const checkWindowSize = () => {
    if (window.innerWidth < 640) {
      // 640px is the default breakpoint for `sm` in Tailwind
      setShowFilters(false); // Hide filters on smaller devices
    } else {
      setShowFilters(true); // Show filters on larger devices
    }
  };

  // useEffect to handle window resize and initial load
  useEffect(() => {
    checkWindowSize(); // Check window size on initial render
    window.addEventListener("resize", checkWindowSize); // Add resize event listener

    return () => {
      window.removeEventListener("resize", checkWindowSize); // Cleanup event listener
    };
  }, []);

  return (
    <>
      <div className={`flex items-center justify-end md:justify-center`}>
        {/* Show/Hide Button for smaller devices */}
        <button
          className="absolute z-50 px-3 py-1 text-white bg-[#8EC639] rounded-md sm:hidden bottom-[10%] left-3"
          onClick={() => setShowFilters(!showFilters)}
        >
          {/* Font Awesome Icon */}
          Filter{" "}
          <i className={`fa ${showFilters ? "fa-times" : "fa-filter"}`}></i>
        </button>
        {showFilters && (
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-7 absolute bottom-4 md:bottom-10 bg-[#ffffffcf] rounded-lg gap-2 md:gap-0 p-2 md:p-4">
            {type === "stays" && <ListingFilters />}
          </div>
        )}
      </div>

      <div className="absolute top-0 w-full">
        <div className="md:flex hidden flex-wrap justify-evenly items-center px-3 bg-white md:w-[80%] mx-auto">
          <div>
            <h3 className="text-md text-nowrap font-bold !m-0">
              Distance From Runway
            </h3>
          </div>
          <button
            className={
              watch("closest_runway") === 0
                ? "custom-button !bg-gray-300 !w-auto"
                : `custom-button !w-auto`
            }
            onClick={() => setValue("closest_runway", 0)}
          >
            <FaDotCircle className="icon" color="#8ec639" size={"20px"} />
            <span className="button-text">0 miles away</span>
          </button>
          <button
            className={
              watch("closest_runway") === 1
                ? "custom-button !bg-gray-300 !w-auto"
                : `custom-button !w-auto`
            }
            onClick={() => setValue("closest_runway", 1)}
          >
            <FaDotCircle className="icon" color="#ffff00" size={"20px"} />
            <span className="button-text">Within 1 Mile</span>
          </button>
          <button
            className={
              watch("closest_runway") === 3
                ? "custom-button !bg-gray-300 !w-auto"
                : `custom-button !w-auto`
            }
            onClick={() => setValue("closest_runway", 3)}
          >
            <FaDotCircle className="icon" color="#f17489" size={"20px"} />
            <span className="button-text">Within 3 Miles</span>
          </button>
          <button
            className={
              watch("closest_runway") === 7
                ? "custom-button !bg-gray-300 !w-auto"
                : `custom-button !w-auto`
            }
            onClick={() => setValue("closest_runway", 7)}
          >
            <FaDotCircle className="icon" color="#ff9900" size={"20px"} />
            <span className="button-text">Within 7 Miles</span>
          </button>
          <button
            className={
              watch("closest_runway") === 8
                ? "custom-button !bg-gray-300 !w-auto"
                : `custom-button !w-auto`
            }
            onClick={() => setValue("closest_runway", 8)}
          >
            <FaDotCircle className="icon" color="#52c4d7" size={"20px"} />
            <span className="button-text">Over 7 Miles away</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default SearchLocation;
